export default __webpack_public_path__ + "static/media/sv44_en_alph_a2.20101459.mp3";